<template>
	<div
			v-if="!!status"
			class="page-status"
			:class="{ 'page-status--no-curl': noPageCurl }"
			:style="`--icon-bg-color: var(--v-${status}-base);`"
	>
		<template v-if="3 === 3 || noPageCurl">
			<v-icon v-if="status === 'success'" class="ma-1" color="success" size="32">
				mdi-checkbox-marked
			</v-icon>
			<v-icon v-if="status === 'error'" class="ma-1" color="error" size="32">
				mdi-close-box
			</v-icon>
			<v-icon v-if="status === 'warning'" class="ma-1" color="warning" size="32">
				mdi-alert-box
			</v-icon>
			<v-icon v-if="status === 'info'" class="ma-1" color="info" size="32"
							style="transform: rotate(-180deg);">
				mdi-alert-box
			</v-icon>
		</template>
		<template v-else>
			<div :class="`page-curl page-curl--${status}`">
				<div>
					<v-icon :key="icon" color="white" small>{{ icon }}</v-icon>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	name: "UiBoxStatus",
	props: {
		noPageCurl: Boolean,
		status: [Boolean, String]
	},
	data() {
		return {
			statuses: [
				{
					name: 'error',
					icon: 'mdi-close-thick'
				},
				{
					name: 'info',
					icon: 'mdi-information-slab-symbol'
				},
				{
					name: 'success',
					icon: 'mdi-check-bold'
				}, {
					name: 'warning',
					icon: 'mdi-exclamation-thick'
				}
			]
		};
	},
	computed: {
		icon() {
			return this.statuses.find(status => status.name === this.status)?.icon;
		}
	}
}

</script>

<style lang="scss" scoped>
@import '../../../../resources/sass/portals/utils/smooth-gradient';

.page-status {
	position: absolute;
	right: 1.25rem;
	top: 1.25rem;
	z-index: 1;

	&::before {
		opacity: 0.08;
		background: var(--icon-bg-color);
		border-radius: 0.375rem;
		bottom: -0.25rem;
		content: '';
		height: 3rem;
		left: -0.25rem;
		position: absolute;
		width: 3rem;
	}

	&--no-curl {
		right: 0.375rem;
		top: 0.375rem;
		width: unset;

		&::before {
			opacity: 0.08;
			background: var(--icon-bg-color);
			border-radius: 0.375rem;
			bottom: -0.25rem;
			content: '';
			height: 3rem;
			left: -0.25rem;
			position: absolute;
			width: 3rem;
		}
	}
}

.page-curl {
	background-color: white;
	border-radius: 0 8px;
	box-shadow: 0 0 0 rgba(0, 0, 0, 0),
	0 0 0 rgba(0, 0, 0, 0),
	0 0 0 rgba(0, 0, 0, 0);
	height: 0;
	overflow: hidden;
	position: absolute;
	right: -1px;
	top: -1px;
	transition: all;
	transition-duration: 0.5s;
	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
	transition-property: background-color, border-color, box-shadow, height, width;
	width: 0;
	z-index: 1;

	&--error,
	&--info,
	&--success,
	&--warning {
		background: linear-gradient(45deg, rgba(0, 0, 0, 0.18) 50%, rgba(0, 0, 0, 0.08) 57%, rgba(0, 0, 0, 0) 70%);
		box-shadow: -6px 6px 20px rgba(0, 0, 0, 0.06),
		-3px 3px 10px rgba(0, 0, 0, 0.09),
		-1px 1px 2px rgba(0, 0, 0, 0.03);
		height: 3rem;
		width: 3rem;
	}

	&--error {
		background-color: var(--v-error-base);
	}

	&--info {
		background-color: var(--v-info-base);
	}

	&--success {
		background-color: var(--v-success-base);
	}

	&--warning {
		background-color: var(--v-warning-base);
	}

	&::after {
		content: '';
		background: linear-gradient(45deg, #{advanced-gradient('easeOutSine', #f5f5f5, #ccc, 0, 50, 0.5, transparent)});
		height: 0;
		position: absolute;
		right: 0;
		top: 0;
		transition-duration: 0.5s;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-property: box-shadow, height, width;
		width: 0;
		z-index: 1;
	}

	&--error::after,
	&--info::after,
	&--success::after,
	&--warning::after {
		height: 3rem;
		width: 3rem;
	}

	& div {
		display: flex;
		height: 28px;
		justify-content: center;
		position: absolute;
		right: 2px;
		top: 2px;
		width: 28px;
		z-index: 2;
	}

	@media (max-width: 959px) {
		border-radius: 0 10.666667px;
		transform: scale(75%);
		transform-origin: top right;
	}
}
</style>
